import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=50f97510&scoped=true&"
import script from "./ModalBase.vue?vue&type=script&lang=js&"
export * from "./ModalBase.vue?vue&type=script&lang=js&"
import style0 from "./ModalBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalBase.vue?vue&type=style&index=1&id=50f97510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f97510",
  null
  
)

export default component.exports